import { Timestamp } from 'firebase/firestore'
import { getLocale } from '@/modules/i18n'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/de-ch'

dayjs.extend(relativeTime)

export { Timestamp }

export function toDate(date?: Date | Timestamp | string) {
  let locale = getLocale()
  if (locale === 'de') {
    // Make sure we use ch-specific locale we imported for de
    locale += '-ch'
  }
  if (date instanceof Timestamp) {
    return dayjs(date.toDate()).locale(locale)
  }
  return dayjs(date).locale(locale)
}

export function getInputDateString(date?: Date) {
  if (date) {
    return dayjs(date).format('YYYY-MM-DD')
  } else return null
}
